/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: React router dom.
import { HiArrowPathRoundedSquare, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({ type, rateId, onRateUpdate, onRateDelete, PassOnUpdate }) => {
  // Hook assignment.
  const _historyRef = useHistory();

  const [_anchorEl, _setAnchorEl] = React.useState(null);
  const _open = Boolean(_anchorEl);

  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget);
  };

  const _handleClose = () => {
    _setAnchorEl(null);
  };

  // Return Component.
  return (
    <>
      <IconButton onClick={_handleClick}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() => {
            // Push rate id to url.
            PassOnUpdate({ rateId, type });

            // Execute handler.
            onRateUpdate();

            _handleClose();
          }}
        >
          <HiPencil size={18} />
          <span>Edit Rate</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push rate id to url.
            PassOnUpdate({ rateId, type });

            // Execute handler.
            onRateDelete();

            _handleClose();
          }}
        >
          <HiTrash size={18} />
          <span>Delete Rate</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push rate id to url.
            PassOnUpdate({ rateId, type });

            // Navigate to rate plan in the same tab.
            _historyRef.push("/rate/plan");

            _handleClose();
          }}
        >
          <HiArrowPathRoundedSquare size={18} />
          <span>Manage Rate Plan</span>
        </MenuItem>
      </Menu>
    </>
  );
};


/*
 * PROPTYPES
 */
Index.propTypes = {
  'type': PropTypes.string,
  'rateId': PropTypes.string,
  'onRateUpdate': PropTypes.func,
  'onRateDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
